/* Copyright (c) 2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Text, theme } from "@nordcloud/gnui";

export function Footer() {
  return (
    <div className="footer">
      <Text size="sm" color={theme.color.text.text02} align="center">
        AutoBackup by Nordcloud Oy © {new Date().getFullYear()}
      </Text>
    </div>
  );
}
